module.exports = __webpack_public_path__ + "img/logo.83a82031.png";